import {
  Box,
  Card,
  Tab,
  Tabs,
  Typography,
  makeStyles,
} from "@material-ui/core";
import STMyPageMessageBoard from "../../assets/styles/organisms/myPageMessageBoard.module.scss";
import { useContext, useState } from "react";
import { routes } from "../../router/Router";
import { getSubdomain } from "../../utils/getSubdomain";
import BottomNavigationBar from "../organisms/BottomNavigationBar";
import BaseHead from "../templates/BaseHead";
import { SiteContext } from "../../providers/SiteProvider";
import TabPanel from "../TabPanel";
import MypageBoardList from "../molecules/MypageBoardList";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    maxWidth: 992,
    border: "1px solid #C7C7C7",
    borderRadius: "24px",
    background: "transparent",
    paddingBottom: 12,
    backgroundColor: "rgba(256, 256, 256, 0.9)",
    boxShadow: "none",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000",
    fontSize: 20,
    fontWeight: 700,
    padding: "16px 8px",
    [theme.breakpoints.up("md")]: {
      fontSize: 24,
      padding: "24px 40px",
    },
  },
  menuName: {
    fontSize: "18px",
    color: "#0E0E0E",
    cursor: "pointer",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      fontWeight: 400,
    },
  },
  divider: {
    backgroundColor: "#D3D3D3",
  },
}));

export const MyPageMessageBoard: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const mainColor = useContext(SiteContext).mainColor;
  const subdomain = getSubdomain(window.location.hostname);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tab = query.get("tab") ? Number(query.get("tab")) : 0;
  const [tabValue, setTabValue] = useState(tab);
  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue === tabValue) return;
    history.push(window.location.pathname + "?tab=" + newValue);
    setTabValue(newValue);
  };

  return (
    <BaseHead title={routes.mypage.title} login subdomain={subdomain}>
      <Box display="flex" justifyContent="center" mt={4} mx={2}>
        <Card
          className={classes.card}
          style={{ minHeight: "calc(100vh - 384px)" }}
        >
          <Typography className={classes.cardHeader}>
            掲示板（投稿・コメント/いいね）
          </Typography>
          <Tabs
            centered
            variant="fullWidth"
            value={tabValue}
            onChange={handleChangeTab}
            className={STMyPageMessageBoard.tabs}
            TabIndicatorProps={{
              style: {
                backgroundColor: tabValue === 1 ? "#ff345c" : mainColor,
              },
            }}
          >
            <Tab
              icon="自分の投稿"
              style={{
                color: tabValue === 0 ? mainColor : "gray",
                backgroundColor: tabValue === 0 ? "#FFF" : "#f0f0f0",
              }}
            />
            <Tab
              icon="コメント／いいねした投稿"
              style={{
                color: tabValue === 1 ? "#ff345c" : "gray",
                backgroundColor: tabValue === 1 ? "#FFF" : "#f0f0f0",
              }}
            />
          </Tabs>
          <TabPanel value={0} index={tabValue}>
            <MypageBoardList isMyBoard />
          </TabPanel>
          <TabPanel value={1} index={tabValue} style={{ overflowY: "auto" }}>
            <MypageBoardList />
          </TabPanel>
        </Card>
      </Box>
      <div>
        <BottomNavigationBar />
      </div>
    </BaseHead>
  );
};
